import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createLocationsSchemas } from 'shared/db/validation/schema/locations';
import { Validator } from 'shared/db/validation/validator';
import {
    LocationRawRecord,
    LocationUpdateRawRecord,
} from 'shared/types/Location';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { LocationDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createLocationsSchemas();

const addValidator = createDBEntityValidator<LocationRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<LocationUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-locations'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createLocationsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const locationsInputValidation: LocationDBValidation = {
    add: createLocationsInputValidation(addValidator, validationStrategy),
    update: createLocationsInputValidation(updateValidator, validationStrategy),
    delete: createLocationsInputValidation(deleteValidator, validationStrategy),
};
